/**
 * Created by Ram on 19/01/2017.
 */

import React, { Component } from 'react';
import { navigate } from '@reach/router'
import CreateAccount from '../presentation/create-account';


export default class CreateAccountWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            organisationName    : null,
            accountType         : null,
            createdId           : null,
            showErrorModal      : false,
            errorMessage        : null
        }
    }

    updateFormState = e => {
        let obj = {};
        obj[e.target.name] = e.target.value;
        this.setState(obj);
    };

    closeModal = () => {
        if( this.state.errorMessage )
            this.setState({ errorMessage: null });
        else {
            this.setState({ showModal: false });
            navigate(`/customer/${this.state.createdId}`);
        }
    };

    openModal = () => {
        this.setState({ showModal: true });
    };

    handleCreateAccount = () => {
        const { organisationName, accountType } = this.state
        const createdBy = localStorage.getItem('userId')
        const params = { organisationName, accountType, createdBy }

        fetch('/service/account', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin',
            body: JSON.stringify(params) 
        }).then(response => {
            if(response.status === 200) {
               response.json().then(res => {
                   const createdId = res.accountId
                   this.setState({ createdId }, this.openModal )
               })
            } else {
                response.json().then(error => alert(error.errorMessage))
            }
        }).catch(console.log)
    };

    render() {
        return <CreateAccount 
                    onCreateAccount={this.handleCreateAccount} 
                    updateFormState={this.updateFormState} 
                    showModal={this.state.showModal} 
                    closeModal={this.closeModal} 
                    errorMessage={this.state.errorMessage} 
                />
    }
}